import { IEducator } from './ieducator';

export interface IEducatorState {
    educator: IEducator,
    educators: Array<IEducator>,
    error?: any
}
